import initialState from './initialState'

/**
 * @description
 * Setter function for the transactionType store variable.
 * @param {*} state
 * @param {*} transactionType
 */
const SET_TRANSACTION_TYPE_INDEX = function(state, activeTransactionIndex) {
    state.activeTransactionIndex = activeTransactionIndex
}
const SWITCH_TRANSACTION_TYPE = function(state) {
    let transactionTypeCount = state.availableTransactions.length
    if (transactionTypeCount - 1 == state.activeTransactionIndex) {
        state.activeTransactionIndex = 0
        return
    }
    state.activeTransactionIndex++
}
const SET_WAIT_AUTH = (state, bool) => {
    state.waitingSupervisorAuth = bool
}

const SET_FORCE_PRINT = (state, object) => {
    state.forcePrint = object
}

const SET_SHOW_MENU = (state, bool) => {
    state.showMenu = bool
}

const SET_SHOW_SEARCH_TYPE = (state, bool) => {
    state.showSearchType = bool
}

const SET_SHOW_INTERNAL_CODE_SEARCH = (state, bool) => {
    state.showInternalCodeSearch = bool
}
const SET_SHOW_MULTI_SELECT_SEARCH = (state, bool) => {
    state.showMultiSelectSearch = bool
}

const SET_EDIT_MODE = (state, bool) => {
    state.editMode = bool
}

const SET_RECOVERED_STORE_PICKUP = (state, bool) =>
    (state.recoveredStorePickup = bool)

const SET_RECOVERED_OC_NUMBER = (state, number) =>
    (state.recoveredOcNumber = number)

const SET_IS_EDITING_DISPATCH_REQUEST = (state, bool) =>
    (state.isEditingDispatchRequest = bool)

const SET_EDITED_DISPATCH_REQUEST_NUMBER = (state, number) =>
    (state.editedDispatchRequestNumber = number)

const SET_EDITING_ORIGIN = (state, number) => (state.editingOrigin = number)
const SET_EDITING_STORE_PICKUP = (state, bool) => (state.editingOrigin = bool)

/**
 * @description
 * Returns State to it's initial values
 * @param {*} state
 */
const RESET_STATE = function(state) {
    Object.assign(state, initialState())
}

export default {
    SET_TRANSACTION_TYPE_INDEX,
    RESET_STATE,
    SWITCH_TRANSACTION_TYPE,
    SET_WAIT_AUTH,
    SET_FORCE_PRINT,
    SET_SHOW_MENU,
    SET_SHOW_SEARCH_TYPE,
    SET_SHOW_INTERNAL_CODE_SEARCH,
    SET_SHOW_MULTI_SELECT_SEARCH,
    SET_EDIT_MODE,
    SET_RECOVERED_OC_NUMBER,
    SET_RECOVERED_STORE_PICKUP,
    SET_IS_EDITING_DISPATCH_REQUEST,
    SET_EDITED_DISPATCH_REQUEST_NUMBER,
    SET_EDITING_ORIGIN,
    SET_EDITING_STORE_PICKUP,
}
